// export const baseUrl = {
//   information: "http://localhost:5000/api",
//   file: "http://localhost:5000/api",
// };

export const baseUrl = {
  information: "https://mrcs-backend.vercel.app/api",
  file: "https://mrcs-backend.vercel.app/api",
};
